module.exports = __webpack_public_path__ + "static/media/Valor.33975e0b.png";